import Cart from "./cart";

const InitCarts = ( selector = '[sh-cart-wrapper]' ) => {
    const elements = document.querySelectorAll( selector );
    if( typeof( elements ) !== 'undefined' && elements.length > 0 ){
        elements.forEach( el => {
            let cart = new Cart(el);
        })
    }
}

export default InitCarts
